import React, { Component } from 'react';
import Box from 'grommet/components/Box';
import Label from 'grommet/components/Label';
import WarningIcon from 'grommet/components/icons/base/Alert';

export default function (props) {
    return(
        <Box size='xlarge' direction='row' margin='none' pad='small' style={{ backgroundColor: '#ffd144',marginBottom:'5px' }}>
            <WarningIcon size='small' margin='small' type='status' />
            <Label style={{ marginLeft: '10px' }} size='medium' margin='none'>{props.message}</Label>
          </Box>
    );
}


// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/SimpleWarning.js